import {
    createApp
} from 'vue'
import App from './App.vue'
import router from './router/index'
import 'vant/lib/index.css';
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
const app = createApp(App).use(router).mount('#app')